import React, { TextareaHTMLAttributes } from 'react';

import TopLabel from '@/components/common/TopLabel/TopLabel';
import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';
import { IModalFormProps } from '../ModalFormProps.interface';
import Textarea from '@/components/common/Textarea/Textarea';

interface IModalFormTextareaProps extends IModalFormProps, TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
}

export default function ModalFormTextarea({
  id,
  className,
  labelTitle,
  requiredIcon,
  validationMessage,
  isFloatingValidation = false,
  ...restProps
}: IModalFormTextareaProps) {
  return (
    <div className={className}>
      {labelTitle && (
        <TopLabel
          id={id}
          label={labelTitle}
          required={requiredIcon}
        />
      )}

      <Textarea
        {...restProps}
      />

      {validationMessage && (
        <ValidationAlert
          isFloating={isFloatingValidation}
          type="danger"
        >
          {validationMessage}
        </ValidationAlert>
      )}
    </div>
  );
}
